import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container, Button } from 'react-bootstrap';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';

import getValidationErrors from '../../../utils/getValidationErrors';

import SelectSync from '../../SelectSync';
import TextArea from '../../TextArea';
import Loading from '../../Loading';
import { ICartaoSaude } from '../../../pages/CartaoSaudeDetalhe';
import getResponseErrors from '../../../utils/getResponseErrors';

type ComponentProps = {
  PlaCodigo: number;
  updated_at: Date;
  handleSalvouMotivo(dados: ICartaoSaude): void;
  handleFechar(): void;
};

interface ISubmitForm {
  MotCodigo: string;
  MotDescricao: string;
}

interface IOptions {
  value: string;
  label: string;
}

const CartaoSaudeMotivoNaoRenovar: React.FC<ComponentProps> = ({
  PlaCodigo,
  updated_at,
  handleSalvouMotivo,
  handleFechar,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [optionsMotivo, setOptionsMotivo] = useState<IOptions[]>([]);
  const formRef = useRef<FormHandles>(null);

  useEffect(() => {
    async function loadMotivos(): Promise<void> {
      try {
        const response = await api.get<
          { MotCodigo: number; MotMotivo: string }[]
        >('motivo?MotTipo=1&MotAtivo=true');

        setOptionsMotivo(
          response.data.map(mot => {
            return { value: mot.MotCodigo.toString(), label: mot.MotMotivo };
          }),
        );
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar motivos',
          type: 'error',
          description: mensagemErro,
        });
      }
    }
    loadMotivos();
  }, [addToast]);

  const handleSubmitForm = useCallback(
    async (dados: ISubmitForm) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          MotCodigo: Yup.string().required('Motivo obrigatório'),
          MotDescricao: Yup.string().required('Descrição obrigatório'),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        const { MotCodigo, MotDescricao } = dados;
        const response = await api.post<ICartaoSaude>(
          `planos/motivonaorenovar/${PlaCodigo}`,
          {
            MotCodigo: Number(MotCodigo),
            MotDescricao: MotDescricao.toUpperCase(),
            updated_at,
          },
        );

        handleSalvouMotivo(response.data);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);
          return;
        }
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar os dependentes',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [PlaCodigo, updated_at, handleSalvouMotivo, addToast],
  );

  return (
    <Container style={{ height: '100%', minHeight: '300px' }}>
      {loading && <Loading />}

      <Form ref={formRef} onSubmit={handleSubmitForm}>
        <SelectSync
          label="Motivo"
          name="MotCodigo"
          options={optionsMotivo}
          handleSelectChange={() => console.log('')}
        />
        <TextArea label="Descrição" name="MotDescricao" rows={5} />
        <Button
          type="submit"
          className="mt-2"
          variant="success"
          disabled={loading}
        >
          Salvar
        </Button>
        <Button
          type="button"
          className="mt-2 ml-3"
          variant="outline-secondary"
          onClick={handleFechar}
          disabled={loading}
        >
          Voltar
        </Button>
      </Form>
    </Container>
  );
};

export default CartaoSaudeMotivoNaoRenovar;
